import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed, ref } from 'vue';
import { TranslateResult } from 'vue-i18n';
import { useChat } from '~/composables/useChat';
import { useId } from '~/composables/useUniqueId';
import { IMessage } from '~/types/chat';
import MessageEmojiPicker from './MessageEmojiPicker.vue';
import NoticeCard from './NoticeCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageInput',
  props: {
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { disabled?: boolean };


const { i18n } = useContext();

const message = ref('');
const error = ref<string | TranslateResult>('');
const isSending = ref(false);
const hintId = useId('hint');
const hintId2 = useId('hint2');
const { channel, pubnub, isUserBanned } = useChat();
const maxLength = 500;
const textarea = ref<HTMLTextAreaElement | null>(null);
const hasError = computed(
  () => !!error.value || (message.value?.length ?? 0) > maxLength,
);

const hintMaxLength = computed(() => {
  if (error.value) {
    return error.value;
  }
  const tParams = {
    currentLength: `${message.value?.length ?? 0}`,
    maxLength: `${maxLength}`,
  };
  return (message?.value?.length ?? 0) >= maxLength
    ? i18n.t(
        `components.chat.messageInput.hints.maxLengthLimitReached`,
        tParams,
      )
    : i18n.t(`components.chat.messageInput.hints.maxLength`, tParams);
});

const insertEmoji = (emoji: string) => {
  message.value += emoji;
};

const sendMessage = async () => {
  if (message.value === '' || !!hasError.value) {
    return;
  }

  try {
    isSending.value = true;
    const messageToPublish: IMessage = {
      text: message.value,
    };
    await pubnub.publish({
      channel: channel.channel,
      message: messageToPublish,
    });
    message.value = '';
  } catch (e) {
    console.error('Error publishing message', e);
    error.value = i18n.t(`components.chat.messageInput.errors.default`);
  }

  isSending.value = false;
};

const handleInput = (e: InputEvent) => {
  if (!!error.value) {
    error.value = '';
  }
};

const handleEnterKeyDown = (e: KeyboardEvent) => {
  // enter + shift should submit
  if (e.shiftKey) {
    e.preventDefault();
    sendMessage();
  }
};

return { __sfc: true,props, i18n, message, error, isSending, hintId, hintId2, channel, pubnub, isUserBanned, maxLength, textarea, hasError, hintMaxLength, insertEmoji, sendMessage, handleInput, handleEnterKeyDown, MessageEmojiPicker, NoticeCard }
}

})